import React, {useState, useEffect} from 'react';
import axios from 'axios';

const PDFAlert = () => {
    const [status, setStatus] = useState(null);

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_BASE_URL}/CheckPdfGenerationHealth`)
            .then(res => {
                if (res.status === 200 && res.data.success && res.data.data === "Health check passed successfully.") {
                    setStatus('success');
                } else {
                    setStatus('error');
                }
            })
            .catch(() => setStatus('error'));
    }, []);


    return (
        <div>
            {status === 'error' && (
                <div className="health-status-case error">PDF-ის გენერირების სერვისი გათიშულია, მიმართეთ ადმინისტრაციას! ❌</div>
            )}
        </div>
    );
};

export default PDFAlert;
